/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const IndustryRadioGroupContainer = styled.div`
  .industry-radio-group-slider {
    position: relative;
    height: calc(100vh - 190px);
    min-height: 520px;

    @media (max-width: 575px) {
      min-height: 0;
    }

    .industry-radio-group-slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease-in-out;
      display: none;

      &.current-slide {
        display: block;
      }
    }
  }
`;

export const OtherOptionsContainer = styled.div`
  width: 100%;
  height: auto;
  min-height: 100%;
  background-color: white;
  position: relative;
  z-index: var(--z-mui-tooltip);

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
    z-index: 1;

    @media (max-width: 575px) {
      position: fixed;
      bottom: 0;
      z-index: var(--z-modal-select);
    }
  }

  .radio-field--group .radio-field-wrapper {
    flex-wrap: nowrap !important;
  }
  .signup-form--other-industry-radio {
    .radio-field-wrapper {
      padding-bottom: 60px;
      .radio-div label {
        font-size: var(--font-size-20);
        @media (max-width: 575px) {
          font-size: var(--font-size-16);
        }
      }
    }
  }
  .signup-form--other-industry-header .slick-prev {
    position: absolute !important;
    margin-top: 0 !important;
    &::before {
      padding: 9px !important;
      @media (max-width: 767px) {
        padding: 7px !important;
      }
    }
  }
`;

export const GafOptionsContainer = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 0 auto;

  .radio-field--title {
    padding: 0 !important;
  }
`;
